import React, {
  createContext,
  useState,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import Cookies from "js-cookie";

const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const initialUser = Cookies.get("vaghfnamaUser")
    ? JSON.parse(Cookies.get("vaghfnamaUser"))
    : {};

  const [user, setUser] = useState(initialUser);
  const [isLoggedIn, setIsLoggedIn] = useState(!!initialUser?.message);

  useEffect(() => {
    setIsLoggedIn(!!user?.message);
  }, [user]);

  const updateUser = useCallback((newData) => {
    setUser(newData);

    if (newData.message === "Login successful") {
      Cookies.set("vaghfnamaUser", JSON.stringify(newData), { expires: 31 });
    }
  }, []);

  const logout = useCallback(() => {
    Cookies.remove("vaghfnamaUser");
    setUser({});
    setIsLoggedIn(false);
  }, []);

  const updateIsLoggedIn = useCallback(
    (state = !!user?.message) => {
      setIsLoggedIn(state);
    },
    [user]
  );

  const contextValue = useMemo(
    () => ({
      user,
      isLoggedIn,
      updateUser,
      logout,
      updateIsLoggedIn,
    }),
    [user, isLoggedIn]
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export { AuthContext, AuthContextProvider };
